import { Intercom } from '@intercom/messenger-js-sdk';
import type React from 'react';
import { useLayoutEffect } from 'react';
import { INTERCOM_APP_ID } from '../../lib/constants.ts';
import { useAppState } from '../../lib/hooks/use-app-state.ts';
import { getFullName } from '../../utils/name.ts';

type Props = {
    children: React.ReactNode | React.ReactNode[];
};

export const IntercomProvider: React.FC<Props> = ({ children }) => {
    const { platoUser } = useAppState();

    // the Intercom dep ultimately mutates the DOM so we use useLayoutEffect
    useLayoutEffect(() => {
        if (!platoUser) {
            return;
        }
        try {
            // the library automatically handles loading/updating existing instances
            Intercom({
                api_base: 'https://api-iam.intercom.io',
                app_id: INTERCOM_APP_ID,
                name: getFullName(platoUser.firstName, platoUser.lastName),
                email: platoUser.email,
                customer_id: platoUser.platoCustomer.id,
                customer_name: platoUser.platoCustomer.name,
                created_at: platoUser?.createdAt ? platoUser.createdAt.getTime() / 1000 : undefined,
                hide_default_launcher: true,
            });
        } catch (error) {
            // don't crash the page if we can't load Intercom
            console.error(`Error loading Intercom`, error);
        }
    }, [platoUser]);

    return children;
};
